import React from "react";

import { ERPType } from "../../types/types";
import Ergo from "./ergo";
import Radix from "./radix";

export default function ERP(props: {
  erp: ERPType[];
  style?: React.CSSProperties;
}) {
  if (props.erp.length === 0) return <></>;

  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        ...props.style,
      }}
    >
      {props.erp.map((item: ERPType) => {
        return (
          <div key={item}>
            {item === ERPType.ergo && <Ergo />}
            {item === ERPType.radix && <Radix />}
          </div>
        );
      })}
    </div>
  );
}
